import { Base, createApp } from '@studiometa/js-toolkit';
import 'liquid-ajax-cart';
import { Slider } from '@studiometa/ui';

/**
 * App
 */
class App extends Base {
  /**
   * App Configuration
   */
  static config = {
    name: 'App',
    components: {
      Slider,
    },
  };
}

export default createApp(App, document.documentElement);
